import { NgModule } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
    IconVolume,
    IconFolder,
    IconSearch,
    IconX,
    IconChevronDown,
    IconMenu2,
    Icon3dCubeSphere,
    Icon3dCubeSphereOff,
    IconActivityHeartbeat,
    IconAlertCircle,
    IconAlignLeft,
    IconAngle,
    IconArrowBack,
    IconArrowMerge,
    IconArrowsMinimize,
    IconArrowsMaximize,
    IconArrowsVertical,
    IconArrowRight,
    IconArrowLeft,
    IconAt,
    IconBan,
    IconBandage,
    IconBarcode,
    IconBaseline,
    IconBell,
    IconBellPlus,
    IconBolt,
    IconBook,
    IconBox,
    IconBrandGoogle,
    IconBrandAppleArcade,
    IconBrandStripe,
    IconBuildingBank,
    IconBuildingHospital,
    IconCake,
    IconCalendar,
    IconCalendarCheck,
    IconCalendarClock,
    IconCalendarEvent,
    IconCalendarMonth,
    IconCalendarWeek,
    IconCamera,
    IconCashBanknote,
    IconCash,
    IconCategory,
    IconChalkboard,
    IconChartDots,
    IconCheck,
    IconChecklist,
    IconCheckupList,
    IconChevronUp,
    IconChevronLeft,
    IconChevronRight,
    IconChisel,
    IconCircle,
    IconCircleFilled,
    IconCircleDashed,
    IconCircleCheck,
    IconClick,
    IconClipboardList,
    IconClipboardText,
    IconCylinderPlus,
    IconClock,
    IconClockX,
    IconCoin,
    IconColumns2,
    IconCopy,
    IconCreditCard,
    IconCreditCardOff,
    IconCurrencyEuro,
    IconDeviceFloppy,
    IconDeviceMobileMessage,
    IconDeviceGamepad,
    IconDimensions,
    IconDots,
    IconDotsCircleHorizontal,
    IconDownload,
    IconEaseInOut,
    IconEdit,
    IconExclamationCircle,
    IconExternalLink,
    IconEye,
    IconEyeSearch,
    IconEyeOff,
    IconEyeExclamation,
    IconFile,
    IconFiles,
    IconFileDescription,
    IconFileDollar,
    IconFileImport,
    IconFileInvoice,
    IconFilePlus,
    IconFileText,
    IconFileTime,
    IconFileUpload,
    IconFileX,
    IconForms,
    IconGridDots,
    IconHelp,
    IconHistory,
    IconHome,
    IconKey,
    IconKeyboard,
    IconLayout,
    IconLayoutBoardSplit,
    IconLayoutColumns,
    IconLayoutRows,
    IconLifebuoy,
    IconLine,
    IconList,
    IconLink,
    IconListDetails,
    IconLock,
    IconLockAccess,
    IconLockOpen,
    IconNote,
    IconNotes,
    IconMail,
    IconMailbox,
    IconMailboxOff,
    IconMailForward,
    IconMapPin,
    IconMicrowave,
    IconMinus,
    IconMinusVertical,
    IconMessage,
    IconMessages,
    IconMessageDots,
    IconMessageCheck,
    IconMessageReply,
    IconMultiplier1x,
    IconMultiplier05x,
    IconMultiplier2x,
    IconRectangleRoundedBottom,
    IconReport,
    IconReportMedical,
    IconReportMoney,
    IconResize,
    IconRuler2Off,
    IconMicrophone,
    IconPaperclip,
    IconPencil,
    IconPin,
    IconPinned,
    IconPinFilled,
    IconPhone,
    IconPhoto,
    IconPhotoPlus,
    IconPlayerStopFilled,
    IconPlayerPlayFilled,
    IconPlayerPauseFilled,
    IconPlayFootball,
    IconPlus,
    IconPrinter,
    IconPrinterOff,
    IconProgress,
    IconRectangleVertical,
    IconRefreshAlert,
    IconRobot,
    IconRotate360,
    IconRotate2,
    IconRotateClockwise2,
    IconRoute,
    IconRefresh,
    IconReload,
    IconRuler,
    IconRuler2,
    IconScale,
    IconScanEye,
    IconSend,
    IconSettings,
    IconShoe,
    IconShoppingCart,
    IconSignature,
    IconSlash,
    IconSparkles,
    IconSpray,
    IconSquare,
    IconStar,
    IconStethoscope,
    IconSwitchVertical,
    IconTag,
    IconTarget,
    IconTargetArrow,
    IconTimeline,
    IconTransfer,
    IconTransferIn,
    IconTransferOut,
    IconTrash,
    IconTriangle,
    IconTriangleInverted,
    IconUpload,
    IconUser,
    IconUserQuestion,
    IconUserCircle,
    IconUserCancel,
    IconUsers,
    IconVaccineBottle,
    IconVectorBezierArc,
    IconVectorSpline, IconVideo, IconWallet, IconWaveSine, IconWorld, IconZoomIn, IconZoomOut,
    // ... tes icônes
} from 'angular-tabler-icons/icons';

const icons = {
    Icon3dCubeSphere,
    Icon3dCubeSphereOff,
    IconActivityHeartbeat,
    IconAlertCircle,
    IconAlignLeft,
    IconAngle,
    IconArrowBack,
    IconArrowMerge,
    IconArrowsMinimize,
    IconArrowsMaximize,
    IconArrowsVertical,
    IconArrowRight,
    IconArrowLeft,
    IconAt,
    IconBan,
    IconBandage,
    IconBarcode,
    IconBaseline,
    IconBell,
    IconBellPlus,
    IconBolt,
    IconBook,
    IconBox,
    IconBrandGoogle,
    IconBrandAppleArcade,
    IconBrandStripe,
    IconBuildingBank,
    IconBuildingHospital,
    IconCake,
    IconCalendar,
    IconCalendarCheck,
    IconCalendarClock,
    IconCalendarEvent,
    IconCalendarMonth,
    IconCalendarWeek,
    IconCamera,
    IconCashBanknote,
    IconCash,
    IconCategory,
    IconChalkboard,
    IconChartDots,
    IconCheck,
    IconChecklist,
    IconCheckupList,
    IconChevronUp,
    IconChevronDown,
    IconChevronLeft,
    IconChevronRight,
    IconChisel,
    IconCircle,
    IconCircleFilled,
    IconCircleDashed,
    IconCircleCheck,
    IconClick,
    IconClipboardList,
    IconClipboardText,
    IconCylinderPlus,
    IconClock,
    IconClockX,
    IconCoin,
    IconColumns2,
    IconCopy,
    IconCreditCard,
    IconCreditCardOff,
    IconCurrencyEuro,
    IconDeviceFloppy,
    IconDeviceMobileMessage,
    IconDeviceGamepad,
    IconDimensions,
    IconDots,
    IconDotsCircleHorizontal,
    IconDownload,
    IconEaseInOut,
    IconEdit,
    IconExclamationCircle,
    IconExternalLink,
    IconEye,
    IconEyeExclamation,
    IconEyeSearch,
    IconEyeOff,
    IconFile,
    IconFiles,
    IconFileDescription,
    IconFileDollar,
    IconFileImport,
    IconFileInvoice,
    IconFilePlus,
    IconFileText,
    IconFileTime,
    IconFileUpload,
    IconFileX,
    IconFolder,
    IconForms,
    IconGridDots,
    IconHelp,
    IconHistory,
    IconHome,
    IconKey,
    IconKeyboard,
    IconLayout,
    IconLayoutBoardSplit,
    IconLayoutColumns,
    IconLayoutRows,
    IconLifebuoy,
    IconLine,
    IconList,
    IconLink,
    IconListDetails,
    IconLock,
    IconLockAccess,
    IconLockOpen,
    IconNote,
    IconNotes,
    IconMail,
    IconMailbox,
    IconMailboxOff,
    IconMailForward,
    IconMapPin,
    IconMicrowave,
    IconMinus,
    IconMinusVertical,
    IconMenu2,
    IconMessage,
    IconMessages,
    IconMessageDots,
    IconMessageCheck,
    IconMessageReply,
    IconMultiplier1x,
    IconMultiplier05x,
    IconMultiplier2x,
    IconRectangleRoundedBottom,
    IconReport,
    IconReportMedical,
    IconReportMoney,
    IconResize,
    IconRuler2Off,
    IconMicrophone,
    IconPaperclip,
    IconPencil,
    IconPin,
    IconPinned,
    IconPinFilled,
    IconPhone,
    IconPhoto,
    IconPhotoPlus,
    IconPlayerStopFilled,
    IconPlayerPlayFilled,
    IconPlayerPauseFilled,
    IconPlayFootball,
    IconPlus,
    IconPrinter,
    IconPrinterOff,
    IconProgress,
    IconRectangleVertical,
    IconRefreshAlert,
    IconRobot,
    IconRotate360,
    IconRotate2,
    IconRotateClockwise2,
    IconRoute,
    IconRefresh,
    IconReload,
    IconRuler,
    IconRuler2,
    IconScale,
    IconScanEye,
    IconSearch,
    IconSend,
    IconSettings,
    IconShoe,
    IconShoppingCart,
    IconSignature,
    IconSlash,
    IconSparkles,
    IconSpray,
    IconSquare,
    IconStar,
    IconStethoscope,
    IconSwitchVertical,
    IconTag,
    IconTarget,
    IconTargetArrow,
    IconTimeline,
    IconTransfer,
    IconTransferIn,
    IconTransferOut,
    IconTrash,
    IconTriangle,
    IconTriangleInverted,
    IconUpload,
    IconUser,
    IconUserCircle,
    IconUserCancel,
    IconUsers,
    IconUserQuestion,
    IconVaccineBottle,
    IconVectorBezierArc,
    IconVectorSpline,
    IconVideo,
    IconVolume,
    IconX,
    IconWallet,
    IconWaveSine,
    IconWorld,
    IconZoomIn,
    IconZoomOut,

};

@NgModule({
    imports: [TablerIconsModule.pick(icons)],
    exports: [TablerIconsModule],
})
export class IconsModule {}